import { createClient, type SupabaseClient, type Session } from "@supabase/supabase-js";

let client: SupabaseClient | null = null;
let initPromise: Promise<SupabaseClient> | null = null;

async function fetchConfig(): Promise<{ supabaseUrl: string; supabaseAnonKey: string }> {
	const res = await fetch("/api/config");
	if (!res.ok) throw new Error("Failed to fetch config");
	return res.json();
}

export async function initSupabaseClient(): Promise<SupabaseClient> {
	if (client) return client;
	if (!initPromise) {
		initPromise = fetchConfig().then(({ supabaseUrl, supabaseAnonKey }) => {
			client = createClient(supabaseUrl, supabaseAnonKey);
			return client;
		});
	}
	return initPromise;
}

function getSupabaseClient(): SupabaseClient {
	if (!client) throw new Error("Supabase client not initialized — call initSupabaseClient() first");
	return client;
}

export async function signInWithGoogle(): Promise<void> {
	const { error } = await getSupabaseClient().auth.signInWithOAuth({
		provider: "google",
		options: { redirectTo: window.location.origin },
	});
	if (error) throw error;
}

export async function signOut(): Promise<void> {
	const { error } = await getSupabaseClient().auth.signOut();
	if (error) throw error;
}

export async function getSession(): Promise<Session | null> {
	const { data } = await getSupabaseClient().auth.getSession();
	return data.session;
}

export async function getAccessToken(): Promise<string | null> {
	const session = await getSession();
	return session?.access_token ?? null;
}

export function onAuthStateChange(callback: (session: Session | null) => void) {
	const { data } = getSupabaseClient().auth.onAuthStateChange((_event, session) => {
		callback(session);
	});
	return data.subscription;
}
